@if (wrapper && wrapper.isReady) {
  <div [formGroup]="wrapper.form" [class]="getFormGroupClass()">
    <acc-form-label [name]="name" [wrapper]="wrapper" [size]="getSize()"/>
    <div class="input-group">
      <!-- No [formControlName]: a file input's value can only be set to '' by the browser; binding it would throw
           "may only be programmatically set to the empty string" on re-render. The file is read via getFile(). -->
      <input #input type="file" class="form-control" [class]="getClass()" placeholder=""
             [id]="name"
             [accept]="getAccept()"
             (change)="onInputChange($event)"
             [class.is-invalid]="isInvalid()"
             [class.disabled]="isViewOnly()">
    </div>
    <acc-form-field-error [name]="name" [wrapper]="wrapper"/>
  </div>
}
